// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2_btK","buttons":"RemoveExpirationActionButtons_buttons__b5e5z"};